// 'anthropic.claude-sonnet-4-5-20250929-v1:0' → 'Claude Sonnet 4.5'. Bedrock
// model ids carry provider, region, snapshot-date and revision noise no author
// needs; an id whose shape isn't recognised is returned untouched rather than
// hiding the detail.
export function modelDisplayName(modelId: string): string {
  const segment = modelId.split('.').find((part) => part.startsWith('claude-'));
  if (segment === undefined) {
    return modelId;
  }
  const words: string[] = [];
  const version: string[] = [];
  for (const token of segment.split('-')) {
    if (/^\d{8}$/.test(token) || /^v\d+(:\d+)?$/.test(token)) {
      break;
    }
    if (/^\d+$/.test(token)) {
      version.push(token);
      continue;
    }
    words.push(token.charAt(0).toUpperCase() + token.slice(1));
  }
  const name = words.join(' ');
  return version.length > 0 ? `${name} ${version.join('.')}` : name;
}
